/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: org_key.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  CreateOrgKeyRequest,
  CreateOrgKeyResponse,
  DeleteOrgKeyRequest,
  DeleteOrgKeyResponse,
  ListOrgKeysRequest,
  ListOrgKeysResponse,
  RotateOrgKeyRequest,
  RotateOrgKeyResponse,
} from '../types/org_key';

export const createOrgKeyService = (transport: Transport) => ({
  async createOrgKey(
    request: CreateOrgKeyRequest,
    options: RequestOptions = {},
  ): Promise<CreateOrgKeyResponse> {
    const { organization_id, ...body } = request;
    const url = getApiPath(API_METHODS.OrgKeyService.CreateOrgKey, { organization_id });
    return transport.post<CreateOrgKeyResponse>(url, body, options);
  },

  async listOrgKeys(
    request: ListOrgKeysRequest,
    options: RequestOptions = {},
  ): Promise<ListOrgKeysResponse> {
    const { organization_id } = request;
    const url = getApiPath(API_METHODS.OrgKeyService.ListOrgKeys, { organization_id });
    return transport.get<ListOrgKeysResponse>(url, options);
  },

  async rotateOrgKey(
    request: RotateOrgKeyRequest,
    options: RequestOptions = {},
  ): Promise<RotateOrgKeyResponse> {
    const { organization_id, org_key_id } = request;
    const url = getApiPath(API_METHODS.OrgKeyService.RotateOrgKey, { organization_id, org_key_id });
    return transport.post<RotateOrgKeyResponse>(url, {}, options);
  },

  async deleteOrgKey(
    request: DeleteOrgKeyRequest,
    options: RequestOptions = {},
  ): Promise<DeleteOrgKeyResponse> {
    const { organization_id, org_key_id } = request;
    const url = getApiPath(API_METHODS.OrgKeyService.DeleteOrgKey, { organization_id, org_key_id });
    return transport.delete<DeleteOrgKeyResponse>(url, options);
  },
});

export type OrgKeyService = ReturnType<typeof createOrgKeyService>;
